import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import AuthService from "../Autenticacao/services/auth.service";

export default class Profile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: null,
      userReady: false,
      currentUser: { username: "" }
    };
  }

  componentDidMount() {
    const currentUser = AuthService.getCurrentUser();

    if (!currentUser) this.setState({ redirect: "/home" });
    this.setState({ currentUser: currentUser, userReady: true })
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />
    }

    const { currentUser } = this.state;

    return (

      <div className="content">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">

                {(this.state.userReady) ?
                  <div>
                    <header className="jumbotron">
                      <h3>
                        <strong style={{textTransform: "capitalize"}}>{currentUser.nome}</strong>
                      </h3>
                    </header>
                    <p>
                      <strong>Token:</strong>{" "}
                      {currentUser.accessToken.substring(0, 20)} ...{" "}
                      {currentUser.accessToken.substr(currentUser.accessToken.length - 20)}
                    </p>
                    <p>
                      <strong>Id:</strong>{" "}
                      {currentUser.id}
                    </p>
                    <p>
                      <strong>E-mail:</strong>{" "}
                      {currentUser.email}
                    </p>
                    <p>
                      <strong>Username:</strong>{" "}
                      {currentUser.username}
                    </p>
                    <p>
                      <strong>Unidade:</strong>{" "}
                      {currentUser.unidade}
                    </p>
                    {/*
                    <strong>Authorities:</strong>
                    <ul>
                      {currentUser.roles &&
                        currentUser.roles.map((role, index) => <li key={index}>{role}</li>)}
                    </ul>
                    */}
                  </div> : null}

              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}
